import { ErrorBoundary } from 'react-error-boundary';
import { ErrorHandler } from "../../app/ErrorHandler";
import ArrowBackIosOutlinedIcon from '@mui/icons-material/ArrowBackIosOutlined';
import { API_REGISTRY } from "../../app/config";
import { clearAPIRegistryData } from "../../app/util";
import {
  AccessTime as LocaleIcon,
  AddAlert as AddAlertIcon,
  AlarmOutlined as SchedulerIcon,
  Apartment as PropertiesIcon,
  ArrowBackOutlined as ArrowBackOutlinedIcon,
  Assessment as ReportsIcon,
  AttachMoneyOutlined as RatePushIcon,
  Bed as DefaultRoomTypePricingIcon,
  Discount as DiscountRuleIcon,
  DomainAddOutlined as AddNewPropertyIcon,
  IntegrationInstructions as IntegrationIcon,
  Inventory as InventoryIcon,
  ManageAccounts as ManageAccountsIcon,
  ManageHistory as ManageRatePlanIcon,
  MonetizationOnOutlined as PricingRulesIcon,
  MoreVertOutlined as MoreVertOutlinedIcon,
  PriceCheck as RatesIcon,
  Refresh as RefreshIcon,
  Security as SecurityIcon,
  Segment as SegmentsIcon,
  Storefront as MarketIcon,
  Summarize as CompsetIcon,
} from "@mui/icons-material/";
import {
  Alert,
  Box,
  Button,
  CircularProgress,
  Container,
  Grid,
  Tooltip,
} from "@mui/material/";
import { ThemeProvider } from "@mui/material/styles";
import React, { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";

import { updateAppState } from "../../actions/appstate";
import { getUserProfile } from "../../actions/auth";
import { PROFILE_SUCCESS, UPDATE_STATE } from "../../actions/types";
import DataService from "../../services/data.service";
import theme from "../../theme";
import Header from "../Header";
import { DashboardFooter } from "../layout/dashboard-ui";
import { ProfileSettings, SecuritySettings } from "./profile-settings";
import {
  AddNewProperty,
  AlertsSettings,
  CompsetSettings,
  DefaultRoomTypePricing,
  DiscountRulesSettings,
  IntegrationSettings,
  InventorySettings,
  LocaleSettings,
  ManageRatePlans,
  MarketsSettings,
  PricingRules,
  RatesSettings,
  SegmentsSettings,
  SegmentsMappingSettings,
  MarketMappingSettings
} from "./property-settings";

import { CustomSVGIcon } from '../layout/dashboard-ui';

import ScheduleReportsSettings from "./scheduler-reports";
import ScheduleRatePushSettings from "./scheduler-ratepush";
import SettingsSideMenu from "./settings-menu";
import tr from 'date-fns/esm/locale/tr/index.js';

//Global custom theme configuration
//import DataService from "../services/data.service";;
//Common UI Elements for screen
const Settings = () => {
  const location = useLocation();
  //User permissions mapping
  //    (0, 'User'),
  //   (1, 'user Admin'),
  //   (2, 'LodgIQ Admin'),
  //   (3, 'Read only'),
  //   (4, 'QA'),
  //   (5, 'Limited'),
  const profileSettingsMenu = [
    {
      id: "profile",
      label: "Profile",
      component: "ProfileSettings",
      index: 1,
      access: [0, 1, 2, 3, 4, 5],
      icon: <span className='profile-icon'></span>,
    },
    {

    }
  ];
  const propertySettingsMenu = [
    {
      id: "inventory",
      label: "Inventory",
      component: "InventorySettings",
      index: 3,
      access: [0, 1, 2, 3, 4, 5],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M208,32H48A16,16,0,0,0,32,48V208a16,16,0,0,0,16,16H208a16,16,0,0,0,16-16V48A16,16,0,0,0,208,32Zm0,16V152h-28.7A15.86,15.86,0,0,0,168,156.69L148.69,176H107.31L88,156.69A15.86,15.86,0,0,0,76.69,152H48V48Zm0,160H48V168H76.69L96,187.31A15.86,15.86,0,0,0,107.31,192h41.38A15.86,15.86,0,0,0,160,187.31L179.31,168H208v40Z"></path></svg>,
    },
    {
      id: "compset",
      label: "Compset *",
      component: "CompsetSettings",
      index: 4,
      access: [2],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M200,224H150.54A266.56,266.56,0,0,0,174,200.25c27.45-31.57,42-64.85,42-96.25a88,88,0,0,0-176,0c0,31.4,14.51,64.68,42,96.25A266.56,266.56,0,0,0,105.46,224H56a8,8,0,0,0,0,16H200a8,8,0,0,0,0-16ZM56,104a72,72,0,0,1,144,0c0,57.23-55.47,105-72,118C111.47,209,56,161.23,56,104Zm112,0a40,40,0,1,0-40,40A40,40,0,0,0,168,104Zm-64,0a24,24,0,1,1,24,24A24,24,0,0,1,104,104Z"></path></svg>,
    },
    {
      id: "rates",
      label: "Rates *",
      component: "RatesSettings",
      index: 5,
      access: [2],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm40-68a28,28,0,0,1-28,28h-4v8a8,8,0,0,1-16,0v-8H104a8,8,0,0,1,0-16h36a12,12,0,0,0,0-24H116a28,28,0,0,1,0-56h4V72a8,8,0,0,1,16,0v8h16a8,8,0,0,1,0,16H116a12,12,0,0,0,0,24h24A28,28,0,0,1,168,148Z"></path></svg>,
    },
    {
      id: "segments",
      label: "Segments",
      component: "SegmentsSettings",
      index: 6,
      access: [0, 1, 2, 3, 4, 5],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path></svg>,
    },
    
    // {
    //   id: "mapping",
    //   label: "Property Mapping",
    //   component: "SegmentsMappingSettings",
    //   index: 12,
    //   access: [0, 1, 2, 3, 4, 5],
    //   icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path></svg>,
    // }
    // ,
    // {
    //   id: "market_mapping",
    //   label: "Market Mapping",
    //   component: "MarketMappingSettings",
    //   index: 13,
    //   access: [0, 1, 2, 3, 4, 5],
    //   icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M32,64a8,8,0,0,1,8-8H216a8,8,0,0,1,0,16H40A8,8,0,0,1,32,64ZM216,96H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H40a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Zm0,40H88a8,8,0,0,0,0,16H216a8,8,0,0,0,0-16Z"></path></svg>,
    // },
    {
      id: "markets",
      label: "Markets *",
      component: "MarketsSettings",
      index: 7,
      access: [2],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z"></path></svg>,
    },
    {
      id: "locale",
      label: "Locale *",
      component: "LocaleSettings",
      index: 8,
      access: [2],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24Zm0,192a88,88,0,1,1,88-88A88.1,88.1,0,0,1,128,216Zm64-88a8,8,0,0,1-8,8H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48h48A8,8,0,0,1,192,128Z"></path></svg>,
    },
    {
      id: "integration",
      label: "Integration *",
      component: "IntegrationSettings",
      index: 9,
      access: [2],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M86.75,44.3,33.48,128l53.27,83.7a8,8,0,0,1-2.46,11.05A7.91,7.91,0,0,1,80,224a8,8,0,0,1-6.76-3.71l-56-88a8,8,0,0,1,0-8.59l56-88a8,8,0,1,1,13.5,8.59Zm152,79.41-56-88a8,8,0,1,0-13.5,8.59L222.52,128l-53.27,83.7a8,8,0,0,0,2.46,11.05A7.91,7.91,0,0,0,176,224a8,8,0,0,0,6.76-3.71l56-88A8,8,0,0,0,238.75,123.71Z"></path></svg>,
    },
    {
      id: "discountrules",
      label: "Discount Rules *",
      component: "DiscountRulesSettings",
      index: 10,
      access: [2],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M243.31,136,144,36.69A15.86,15.86,0,0,0,132.69,32H40a8,8,0,0,0-8,8v92.69A15.86,15.86,0,0,0,36.69,144L136,243.31a16,16,0,0,0,22.63,0l84.68-84.68a16,16,0,0,0,0-22.63Zm-96,96L48,132.69V48h84.69L232,147.31ZM96,84A12,12,0,1,1,84,72,12,12,0,0,1,96,84Z"></path></svg>,
    },

    {
      id: "alerts",
      label: "Alerts",
      component: "AlertsSettings",
      index: 11,
      access: [0, 1, 2, 3, 4, 5],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M224,71.1a8,8,0,0,1-10.78-3.42,94.13,94.13,0,0,0-33.46-36.91,8,8,0,1,1,8.54-13.54,111.46,111.46,0,0,1,39.12,43.09A8,8,0,0,1,224,71.1ZM35.71,72a8,8,0,0,0,7.1-4.32A94.13,94.13,0,0,1,76.27,30.77a8,8,0,1,0-8.54-13.54A111.46,111.46,0,0,0,28.61,60.32,8,8,0,0,0,35.71,72Zm186.1,103.94A16,16,0,0,1,208,200H167.2a40,40,0,0,1-78.4,0H48a16,16,0,0,1-13.79-24.06C43.22,160.39,48,138.28,48,112a80,80,0,0,1,160,0C208,138.27,212.78,160.38,221.81,175.94ZM150.62,200H105.38a24,24,0,0,0,45.24,0ZM208,184c-10.64-18.27-16-42.49-16-72a64,64,0,0,0-128,0c0,29.52-5.38,53.74-16,72Z"></path></svg>,
    },
    // {
    //   id: "managerateplans",
    //   label: "Manage Rate Plans",
    //   component: "ManageRatePlans",
    //   index: 12,
    //   icon: <span className='pricing-rules-icon'></span>,
    // },
    // {
    //   id: "pricingrules",
    //   label: "Pricing Rules",
    //   component: "PricingRules",
    //   index: 13,
    //   icon: <span className='pricing-rules-icon'></span>,
    // },
    {
      id: "defaultroomtypepricing",
      label: "Pricing Seasons",
      component: "DefaultRoomTypePricing",
      index: 14,
      access: [0, 1, 2, 3, 4, 5],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M208,72H24V48A8,8,0,0,0,8,48V208a8,8,0,0,0,16,0V176H232v32a8,8,0,0,0,16,0V112A40,40,0,0,0,208,72ZM24,88H96v72H24Zm88,72V88h96a24,24,0,0,1,24,24v48Z"></path></svg>,
    },
    // {
    //   id: "addnewproperty",
    //   label: "Add New Property",
    //   component: "AddNewProperty",
    //   index: 15,
    //   icon: <AddNewPropertyIcon color="white" sx={{ width: 17 }} />,
    //   isLast: true,
    // },
  ];
  const schedulerSettingsMenu = [
    {
      id: "reports",
      label: "Reports",
      component: "ScheduleReportsSettings",
      index: 16,
      access: [0, 1, 2, 3, 4, 5],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M224,200h-8V40a8,8,0,0,0-8-8H152a8,8,0,0,0-8,8V80H96a8,8,0,0,0-8,8v40H48a8,8,0,0,0-8,8v64H32a8,8,0,0,0,0,16H224a8,8,0,0,0,0-16ZM160,48h40V200H160ZM104,96h40V200H104ZM56,144H88v56H56Z"></path></svg>,
    },
    {
      id: "ratepush",
      label: "Rate Push",
      component: "ScheduleRatePushSettings",
      index: 17,
      access: [0, 1, 2, 3, 4, 5],
      icon: <svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M200,168a48.05,48.05,0,0,1-48,48H136v16a8,8,0,0,1-16,0V216H104a48.05,48.05,0,0,1-48-48,8,8,0,0,1,16,0,32,32,0,0,0,32,32h48a32,32,0,0,0,0-64H112a48,48,0,0,1,0-96h8V24a8,8,0,0,1,16,0V40h8a48.05,48.05,0,0,1,48,48,8,8,0,0,1-16,0,32,32,0,0,0-32-32H112a32,32,0,0,0,0,64h40A48.05,48.05,0,0,1,200,168Z"></path></svg>,
      isLast: true,
    },
  ];
  const settingsComponentsMap = {
    ProfileSettings: <ProfileSettings></ProfileSettings>,
    SecuritySettings: <SecuritySettings></SecuritySettings>,
    InventorySettings: <InventorySettings></InventorySettings>,
    CompsetSettings: <CompsetSettings></CompsetSettings>,
    RatesSettings: <RatesSettings></RatesSettings>,
    SegmentsSettings: <SegmentsSettings></SegmentsSettings>,
    SegmentsMappingSettings: <SegmentsMappingSettings></SegmentsMappingSettings>,
    MarketMappingSettings: <MarketMappingSettings></MarketMappingSettings>,
    MarketsSettings: <MarketsSettings></MarketsSettings>,
    LocaleSettings: <LocaleSettings></LocaleSettings>,
    IntegrationSettings: <IntegrationSettings></IntegrationSettings>,
    DiscountRulesSettings: <DiscountRulesSettings></DiscountRulesSettings>,
    AlertsSettings: <AlertsSettings></AlertsSettings>,
    ManageRatePlans: <ManageRatePlans></ManageRatePlans>,
    PricingRules: <PricingRules></PricingRules>,
    DefaultRoomTypePricing: <DefaultRoomTypePricing></DefaultRoomTypePricing>,
    AddNewProperty: <AddNewProperty></AddNewProperty>,
    ScheduleReportsSettings: (
      <ScheduleReportsSettings></ScheduleReportsSettings>
    ),
    ScheduleRatePushSettings: (
      <ScheduleRatePushSettings></ScheduleRatePushSettings>
    ),
  };

  const { app, auth } = useSelector((state) => state);
  const { app_state, ui_state } = app.current_state;
  const { user } = auth;
  const { user_login_type } = user;
  const ActiveSettingsComponent = () => {
    const {
      activeSettingsComponentName,
      active_settings_menu,
      settingsActiveItem,
    } = ui_state;
    let component = activeSettingsComponentName;
    if (ui_state.isFromHeader) {
      component = eval(active_settings_menu)[0].component;
    }
    if (!component) return "";
    return <ErrorBoundary FallbackComponent={ErrorHandler}>{settingsComponentsMap[component]}</ErrorBoundary>;
  };
  const navigate = useNavigate();
  const isFromHeader = ui_state.isFromHeader;
  const dispatch = useDispatch();
  const active_settings_menu = ui_state.active_settings_menu;
  const { settingsActiveIndex } = ui_state;
  const [expanded, setExpanded] = useState(active_settings_menu);
  const [selectedIndex, setSelectedIndex] = useState(settingsActiveIndex);
  const [refreshingData, setRefreshingData] = useState(false);
  const [refreshedData, setRefreshedData] = useState(false);
  let selected_index = settingsActiveIndex;
  if (active_settings_menu == "profileSettingsMenu") selected_index = 1;
  if (active_settings_menu == "propertySettingsMenu") selected_index = 3;
  if (active_settings_menu == "schedulerSettingsMenu") selected_index = 16;

  const active_settings_menu_map = {
    profile_settings: "Profile Settings",
    property_settings: "Property Settings",
    scheduler_settings: "Schedule Settings",
  };

  const active_settings_classNames = {
    ProfileSettings: "profile-settings",
    ScheduleReportsSettings: "scheduler reports",
    ScheduleRatePushSettings: "scheduler ratepush",
  };

  if (ui_state.isFromHeader) {
    const settingsActiveItem = eval(active_settings_menu)[0];
    dispatch({
      type: UPDATE_STATE,
      payload: {
        ui_state: {
          isFromHeader: false,
          activeSettingsComponentName: settingsActiveItem.component,
          settingsActiveIndex: selected_index,
        },
      },
    });
  }

  const handleChange = (panel, ind) => (event, isExpanded) => {
    setSelectedIndex(settingsActiveIndex);
    setExpanded(isExpanded ? panel : false);
    //setSelectedIndex(selected_index);
    if (isExpanded) {
      dispatch({
        type: UPDATE_STATE,
        payload: { ui_state: { active_settings_menu: panel } },
      });
    }
  };

  // function refreshData() {
  //   // const payload = {
  //   //   token_string: user.token_string,
  //   //   resourceId: app_state.property_id,
  //   //   resourceType: "property",
  //   //   targetCache: ["srr", "forecast", "otb"],
  //   //   operation: "flush",
  //   // };
  //   // setRefreshingData(true);
  //   // // debugger;
  //   // DataService.getData({ api: "rms/properties/clear-cache/" + app_state.property_id + "/" + app_state.active_data_src.id + "/", request: { method: 'GET' } })
  //   //   .then((data) => {
  //   //     //Do some task here just after respons
  //   //     if (data.status === "success") {
  //   //       setRefreshedData(true);
  //   //       setRefreshingData(false);
  //   //       console.log("refreshData Success");
  //   //       setTimeout(() => {
  //   //         setRefreshedData(false);
  //   //         // window.location.reload();
  //   //       }, 2000);
  //   //       clearAPIRegistryData();
  //   //     } else {
  //   //       setRefreshingData(false);
  //   //       console.warn("refreshData Error, data could not refreshed");
  //   //       setTimeout(() => {
  //   //         setRefreshedData(false);
  //   //       }, 3000);
  //   //     }
  //   //   })
  //   //   .catch((err) => {
  //   //     setRefreshingData(false);
  //   //     setTimeout(() => {
  //   //       setRefreshedData(false);
  //   //     }, 3000);
  //   //   });

  //   // getUserProfile({
  //   //   api: "users/get_profile",
  //   //   request: { token_string: user.token_string, user_id: user.user_id },
  //   // })
  //   //   .then((data) => {
  //   //     setRefreshingData(false);
  //   //     console.log("refreshData Success");
  //   //     console.warn("refreshData Error, data could not refreshed");
  //   //     dispatch({ type: PROFILE_SUCCESS, payload: data.user_profile });
  //   //   })
  //   //   .catch((err) => {
  //   //     setRefreshingData(false);
  //   //     console.warn("refreshData Error, data could not refreshed");
  //   //   });
  // }

  function goBackToDashboard() {
    dispatch(
      updateAppState("navigate_to_dashboard", {
        app_state: {
          data_load: true,
          kpi_load: true,
        },
        ui_state: {
          active_settings_menu: "",
          showspinner: true,
        },
      }, "settings_click")
    );
    navigate("/");
  }


  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [isArrowButtonClicked, setIsArrowButtonClicked] = useState(false);
  const handleSidebarMouseEnter = () => {
    setIsSidebarCollapsed(true);
  };
  const handleSidebarMouseLeave = () => {
    if (!isArrowButtonClicked) {
      setIsSidebarCollapsed(false);
    }
    else {
      setIsSidebarCollapsed(true);
    }
  };
  const toggleSidebar = () => {
    setIsSidebarCollapsed(!isSidebarCollapsed);
    // if(isSidebarCollapsed){
    //   setIsArrowButtonClicked(prevState => !prevState);
    //   setIsSidebarCollapsed(true);
    // }
    // else{
    //   setIsArrowButtonClicked(prevState => !prevState);
    //   setIsSidebarCollapsed(false);
    // }
  };


  return (
    <ThemeProvider theme={theme}>
      <Box className="settings" sx={{ backgroundColor: "white.main", minHeight: "100%" }}>
        <Header />

        <Grid
          className={active_settings_classNames[ui_state.activeSettingsComponentName]}
          container
          display="flex"
          sx={{ minHeight: "calc(100vh - 35px)" }}
        >

          {/* settings side menu */}
          <Grid
            className={`setting-sidemenu ${!isSidebarCollapsed ? "" : "collapsed"}`}
            //onMouseEnter={handleSidebarMouseEnter}
            //onMouseLeave={handleSidebarMouseLeave}
          >
            <div className="sidemenu-arrow-icon" onClick={toggleSidebar}>
              {isSidebarCollapsed ?
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M184.49,136.49l-80,80a12,12,0,0,1-17-17L159,128,87.51,56.49a12,12,0,1,1,17-17l80,80A12,12,0,0,1,184.49,136.49Z"></path></svg>
                :
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M168.49,199.51a12,12,0,0,1-17,17l-80-80a12,12,0,0,1,0-17l80-80a12,12,0,0,1,17,17L97,128Z"></path></svg>
              }
              {/* {isSidebarCollapsed ? "<" : ">"}  */}
            </div>
            <Container className='sideMenuContainer' style={{ minHeight: "100%" }}>

              {/* Profile menu */}
              {isSidebarCollapsed ?
                <svg className='collapsedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"></path></svg>
                :
                <SettingsSideMenu
                  className="profileSettingsMenu"
                  menuIcon={<svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M128,24A104,104,0,1,0,232,128,104.11,104.11,0,0,0,128,24ZM74.08,197.5a64,64,0,0,1,107.84,0,87.83,87.83,0,0,1-107.84,0ZM96,120a32,32,0,1,1,32,32A32,32,0,0,1,96,120Zm97.76,66.41a79.66,79.66,0,0,0-36.06-28.75,48,48,0,1,0-59.4,0,79.66,79.66,0,0,0-36.06,28.75,88,88,0,1,1,131.52,0Z"></path></svg>}
                  handleChange={handleChange}
                  expanded={active_settings_menu === "profileSettingsMenu"}
                  menuId="profileSettingsMenu"
                  activeItemIndex={selected_index}
                  title="Profile settings"
                  data={profileSettingsMenu}
                  isFromHeader={isFromHeader}
                />
              }

              {/* Property settings menu */}
              {isSidebarCollapsed ?
                <svg className='collapsedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z"></path></svg>
                :
                <SettingsSideMenu
                  className="propertySettingsMenu"
                  menuIcon={<svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M240,208H224V96a16,16,0,0,0-16-16H144V32a16,16,0,0,0-24.88-13.32L39.12,72A16,16,0,0,0,32,85.34V208H16a8,8,0,0,0,0,16H240a8,8,0,0,0,0-16ZM208,96V208H144V96ZM48,85.34,128,32V208H48ZM112,112v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm-32,0v16a8,8,0,0,1-16,0V112a8,8,0,1,1,16,0Zm0,56v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Zm32,0v16a8,8,0,0,1-16,0V168a8,8,0,0,1,16,0Z"></path></svg>}
                  handleChange={handleChange}
                  expanded={active_settings_menu === "propertySettingsMenu"}
                  menuId="propertySettingsMenu"
                  activeItemIndex={selected_index}
                  title={<span style={{ marginTop: "2px" }}>Property settings</span>}
                  data={propertySettingsMenu}
                  isFromHeader={isFromHeader}
                />
              }

              {/* Scheduler menu */}
              {isSidebarCollapsed ?
                <svg className='collapsedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M128,32a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,32Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,208ZM61.66,29.66l-32,32A8,8,0,0,1,18.34,50.34l32-32A8,8,0,1,1,61.66,29.66Zm176,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,237.66,61.66ZM184,120a8,8,0,0,1,0,16H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48Z"></path></svg>
                :
                <SettingsSideMenu
                  className="schedulerSettingsMenu"
                  menuIcon={<svg className='expandedIcons' xmlns="http://www.w3.org/2000/svg" fill="#F8F9FA" viewBox="0 0 256 256"><path d="M128,32a96,96,0,1,0,96,96A96.11,96.11,0,0,0,128,32Zm0,176a80,80,0,1,1,80-80A80.09,80.09,0,0,1,128,208ZM61.66,29.66l-32,32A8,8,0,0,1,18.34,50.34l32-32A8,8,0,1,1,61.66,29.66Zm176,32a8,8,0,0,1-11.32,0l-32-32a8,8,0,0,1,11.32-11.32l32,32A8,8,0,0,1,237.66,61.66ZM184,120a8,8,0,0,1,0,16H128a8,8,0,0,1-8-8V72a8,8,0,0,1,16,0v48Z"></path></svg>}
                  handleChange={handleChange}
                  expanded={active_settings_menu === "schedulerSettingsMenu"}
                  menuId="schedulerSettingsMenu"
                  activeItemIndex={selected_index}
                  title="Scheduler"
                  data={schedulerSettingsMenu}
                  isFromHeader={isFromHeader}
                />
              }


            </Container>
          </Grid>

          {/* settings body */}
          <Grid
            item
            className={`settings-forms ${!isSidebarCollapsed ? "" : "collapsed"}`}
          >

            {/* <Box className='top-axn-bar-1'
            >
              <Tooltip title="Back to Dashboard" arrow followCursor >
                <Button
                  size="medium"
                  variant="contained"
                  className='back-to-dash-btn'
                  onClick={goBackToDashboard}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" width="16.001" height="16.001" viewBox="0 0 16.001 16.001">
                    <g id="Group_2234" data-name="Group 2234" transform="translate(24154 19449)">
                      <path id="Path_3278" data-name="Path 3278" d="M.889,0h8.3a.889.889,0,0,1,.889.889V9.482a.889.889,0,0,1-.889.889H.889A.889.889,0,0,1,0,9.482V.889A.889.889,0,0,1,.889,0Z" transform="translate(-24154 -19449)" fill="#606060" />
                      <g id="Path_3279" data-name="Path 3279" transform="translate(-24142.74 -19449)" fill="#333">
                        <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                        <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                      </g>
                      <g id="Path_3280" data-name="Path 3280" transform="translate(-24142.74 -19443.371)" fill="#333">
                        <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                        <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                      </g>
                      <g id="Path_3283" data-name="Path 3283" transform="translate(-24142.74 -19437.74)" fill="#333">
                        <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                        <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                      </g>
                      <g id="Path_3281" data-name="Path 3281" transform="translate(-24154 -19437.74)" fill="#333">
                        <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                        <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                      </g>
                      <g id="Path_3282" data-name="Path 3282" transform="translate(-24148.369 -19437.74)" fill="#333">
                        <path d="M 3.852076530456543 4.341016292572021 L 0.8889365196228027 4.341016292572021 C 0.6193365454673767 4.341016292572021 0.3999965190887451 4.121676445007324 0.3999965190887451 3.852076530456543 L 0.3999965190887451 0.8889365196228027 C 0.3999965190887451 0.6193365454673767 0.6193365454673767 0.3999965190887451 0.8889365196228027 0.3999965190887451 L 3.852076530456543 0.3999965190887451 C 4.121676445007324 0.3999965190887451 4.341016292572021 0.6193365454673767 4.341016292572021 0.8889365196228027 L 4.341016292572021 3.852076530456543 C 4.341016292572021 4.121676445007324 4.121676445007324 4.341016292572021 3.852076530456543 4.341016292572021 Z" stroke="none" />
                        <path d="M 0.8889365196228027 0.7999966144561768 C 0.8398964405059814 0.7999966144561768 0.7999966144561768 0.8398964405059814 0.7999966144561768 0.8889365196228027 L 0.7999966144561768 3.852076530456543 C 0.7999966144561768 3.901116609573364 0.8398964405059814 3.941016674041748 0.8889365196228027 3.941016674041748 L 3.852076530456543 3.941016674041748 C 3.901116609573364 3.941016674041748 3.941016674041748 3.901116609573364 3.941016674041748 3.852076530456543 L 3.941016674041748 0.8889365196228027 C 3.941016674041748 0.8398964405059814 3.901116609573364 0.7999966144561768 3.852076530456543 0.7999966144561768 L 0.8889365196228027 0.7999966144561768 M 0.8889365196228027 -3.337860107421875e-06 L 3.852076530456543 -3.337860107421875e-06 C 4.343016624450684 -3.337860107421875e-06 4.741016387939453 0.3979964256286621 4.741016387939453 0.8889365196228027 L 4.741016387939453 3.852076530456543 C 4.741016387939453 4.343016624450684 4.343016624450684 4.741016387939453 3.852076530456543 4.741016387939453 L 0.8889365196228027 4.741016387939453 C 0.3979964256286621 4.741016387939453 -3.337860107421875e-06 4.343016624450684 -3.337860107421875e-06 3.852076530456543 L -3.337860107421875e-06 0.8889365196228027 C -3.337860107421875e-06 0.3979964256286621 0.3979964256286621 -3.337860107421875e-06 0.8889365196228027 -3.337860107421875e-06 Z" stroke="none" fill="#333" />
                      </g>
                    </g>
                  </svg>
                  <span className='back-to-dash-txt'>Back to Dashboard</span>
                </Button>
              </Tooltip>

              <Tooltip title="Refresh Data" >
                <box
                  onClick={refreshData}
                  size="medium"
                  variant="contained"
                  className='refresh-btn'
                // sx={{
                //   color: "white.main",
                //   backgroundColor: "#01A4EF",
                // }}
                >
                  <svg xmlns="http://www.w3.org/2000/svg" fill="#00415F" viewBox="0 0 256 256"><path d="M240,56v48a8,8,0,0,1-8,8H184a8,8,0,0,1,0-16H211.4L184.81,71.64l-.25-.24a80,80,0,1,0-1.67,114.78,8,8,0,0,1,11,11.63A95.44,95.44,0,0,1,128,224h-1.32A96,96,0,1,1,195.75,60L224,85.8V56a8,8,0,1,1,16,0Z"></path></svg>
                </box>
              </Tooltip>

            </Box> */}

            {/* <Box className='top-axn-bar'
              sx={{ background: '#F5F5F5', boxShadow: '0 0 3px #000', pt: 0, pb: { lg: 1.5, xs: 5 } }}
            >
              <Container style={{ maxWidth: "100%", minHeight: "100%" }}>
                <Grid
                  container
                  display="flex"
                  sx={{ pt: { xs: 5, sm: 4.5, md: 7, lg: 7.3 } }}
                >
                  <Alert
                    icon={false}
                    sx={{
                      display: refreshedData ? "block" : "none",
                      position: "fixed",
                      left: 0,
                      fontSize: 17,
                      textAlign: "center",
                      borderRadius: 0,
                      lineHeight: 1.5,
                      bottom: 30,
                      width: "100%",
                      zIndex: 100,
                      backgroundColor: "green.main",
                      color: "white.main",
                    }}
                    severity="success"
                  >
                    Data refreshed successfully!
                  </Alert>

                  <Grid item xs sx={{ textAlign: "center" }}>
                    <Box
                      sx={{
                        textAlign: "right",
                        position: "relative",
                        top: 5,
                        width: "100%",
                        display: { lg: "none" },
                      }}
                    >
                      <Button
                        size="medium"
                        variant="contained"
                        sx={{ color: "white.main", backgroundColor: "green.main" }}
                      >
                        <MoreVertOutlinedIcon fontSize="medium"></MoreVertOutlinedIcon>
                      </Button>
                    </Box>
                  </Grid>

                </Grid>
              </Container>
            </Box> */}

            <Box sx={{ position: 'relative' }}>
            
              <ActiveSettingsComponent></ActiveSettingsComponent>

            </Box>

          </Grid>


        </Grid>



        {refreshingData && (
          <Box
            sx={{
              textAlighn: "center",
              backgroundColor: "dark.darkest",
              opacity: 0.8,
              position: "fixed",
              top: 40,
              left: 0,
              width: "100%",
              height: "100%",
            }}
          >
            <CircularProgress
              size={40}
              sx={{
                color: "white",
                position: "absolute",
                top: "50%",
                left: "50%",
                marginTop: "-20px",
                marginLeft: "-20px",
              }}
            />
          </Box>
        )}
      </Box>
      <DashboardFooter />
    </ThemeProvider>
  );
};
export default Settings;
